import o from "./ghl-ui.es798.js";
import t from "./ghl-ui.es799.js";
import a from "./ghl-ui.es800.js";
import r from "./ghl-ui.es801.js";
import e from "./ghl-ui.es802.js";
var m = {
  code: "en-US",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const s = m;
export {
  s as default
};
